import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ClassSearchCopy } from '@members/copy';

export const SearchSparkle: React.FC<React.PropsWithChildren<{ searchTerms: any[] }>> = ({
  searchTerms,
}) => {
  const [searchQueryIndex, setSearchQueryIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSearchQueryIndex((prevIndex: number) => (prevIndex + 1) % searchTerms.length);
    }, 4500); // Matches the animation cycle time

    return () => clearInterval(intervalId);
  }, [searchTerms.length]);

  return (
    <Sparkle>
      <ClassSearchCopy id={searchTerms[searchQueryIndex]} />
    </Sparkle>
  );
};

const Sparkle = styled.span`
  margin-left: 4px;
  opacity: 0;
  animation: fadeAndSlide 4500ms ease-in-out infinite;
  white-space: nowrap;

  @keyframes fadeAndSlide {
    0%,
    100% {
      opacity: 0;
      transform: translateY(-100%);
    }
    10% {
      opacity: 0;
      transform: translateY(-100%);
    }
    11% {
      opacity: 0;
      transform: translateY(
        100%
      ); /* Positions the next text off-screen, ready to move in */
    }
    20% {
      opacity: 1;
      transform: translateY(-10%); /* Subtle bounce effect as the text moves into view */
    }
    30% {
      opacity: 1;
      transform: translateY(0); /* Text settles into its final position */
    }
    90% {
      opacity: 1;
      transform: translateY(0); /* Maintains visibility before fading out */
    }
    95% {
      opacity: 1;
      transform: translateY(10%); /* Begins to move out with a subtle bounce */
    }
  }
`;
